module.exports = __webpack_public_path__ + "4f4eaef8aed953840754f867f3ecf495.pdf";